import { createContext } from 'react';
import { ICreateUserContext } from '@/containers/pages/user/feature/create-user';

export const CreateUserContext = createContext<ICreateUserContext>({} as ICreateUserContext);
